// extracted by mini-css-extract-plugin
module.exports = {"container":"_2G5B0","isTop":"_3raGI","pagination":"_2fyyE","arrow":"_3H3Bu","page":"_25MBS","active":"BeUia"};